export const EVENT_NAME = {
  OPEN: "Open",
  CANCEL_SUCCESS: "Cancel Withdrawal Success",
  CANCEL_ERROR: "Cancel Withdrawal Error",
  CANCEL_ATTEMPT: "Cancel Withdrawal Attempt",
  CALL_CS: "Call Customer Services",
  DELETE: "Delete"
};
